import { useEffect, useState, useCallback, useRef, useLayoutEffect } from "react";
import "./nav.css";
import gsap from "gsap";
import CustomEase from "gsap/CustomEase";
import houseListImage from '../assets/img/hoselist1.webp'; // Import the image
import { Link } from "react-router-dom";
import { IoMdClose } from "react-icons/io";


const Nav = ({ isOpen, onClose }) => {
  const [isAnimating, setIsAnimating] = useState(false);
  const menuRef = useRef(null);
  const isInitializedRef = useRef(false);

  useLayoutEffect(() => {
    gsap.registerPlugin(CustomEase);
    CustomEase.create(
      "hop",
      "M0,0 C0.354,0 0.464,0.133 0.498,0.502 0.532,0.872 0.651,1 1,1"
    );
  }, []);

  useEffect(() => {
    if (menuRef.current) {
      const menu = menuRef.current;
      const links = menu.querySelectorAll(".link");
      const socialLinks = menu.querySelectorAll(".socials p");

      gsap.set(menu, {
        clipPath: "polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)",
      });
      gsap.set(links, { y: 30, opacity: 0 });
      gsap.set(socialLinks, { y: 30, opacity: 0 });
      gsap.set(".header h1 span", {
        y: 500,
        rotateY: 90,
        scale: 0.8,
      });

      isInitializedRef.current = true;
      if (isOpen) {
        animateMenu(true);
      } else {
        animateMenu(false);
      }
    }
    // animateMenu is a stable useCallback; the effect must only react to isOpen
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const animateMenu = useCallback((open) => {
    if (!menuRef.current) {
      console.log("Menu ref is not available");
      return;
    }

    const menu = menuRef.current;
    const links = menu.querySelectorAll(".link");
    const socialLinks = menu.querySelectorAll(".socials p");

    setIsAnimating(true);

    if (open) {
      gsap.to(menu, {
        clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
        ease: "hop",
        duration: 1.5,
        onStart: () => {
          menu.style.pointerEvents = "all";
        },
        onComplete: () => {
          setIsAnimating(false);
        },
      });

      gsap.to(links, {
        y: 0,
        opacity: 1,
        stagger: 0.1,
        delay: 0.85,
        duration: 1,
        ease: "power3.out",
      });

      gsap.to(socialLinks, {
        y: 0,
        opacity: 1,
        stagger: 0.05,
        delay: 0.85,
        duration: 1,
        ease: "power3.out",
      });

      gsap.to(".video-wrapper", {
        clipPath: "polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)",
        ease: "hop",
        duration: 1.5,
        delay: 0.5,
      });

      gsap.to(".header h1 span", {
        rotateY: 0,
        stagger: 0.05,
        delay: 0.75,
        duration: 1.5,
        ease: "power4.out",
      });

      gsap.to(".header h1 span", {
        y: 0,
        scale: 1,
        stagger: 0.05,
        delay: 0.5,
        duration: 1.5,
        ease: "power4.out",
      });
    } else {
      // Close animation
      gsap.to(links, {
        y: 30,
        opacity: 0,
        stagger: 0.05,
        duration: 0.5,
        ease: "power3.in",
      });

      gsap.to(socialLinks, {
        y: 30,
        opacity: 0,
        stagger: 0.05,
        duration: 0.5,
        ease: "power3.in",
      });

      gsap.to(".video-wrapper", {
        clipPath: "polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)",
        duration: 1,
        ease: "hop",
      });

      gsap.to(".header h1 span", {
        rotateY: 90,
        y: 500,
        scale: 0.8,
        stagger: 0.03,
        duration: 0.8,
        ease: "power4.in",
      });

      // Menu closing animation
      gsap.to(menu, {
        clipPath: "polygon(0% 100%, 100% 100%, 100% 100%, 0% 100%)",
        ease: "hop",
        duration: 1.5,
        delay: 0.2,
        onStart: () => {
          menu.style.pointerEvents = "none";
        },
        onComplete: () => {
          setIsAnimating(false);
          if (onClose) {
            onClose();
          }
        },
      });
    }
  }, [onClose]);

  const handleCloseClick = () => {
    if (!isAnimating) {
      animateMenu(false);
    }
  };

  const splitTextIntoSpans = (text) => {
    return text
      .split("")
      .map((char, index) =>
        char === " " ? (
          <span key={index}>&nbsp;&nbsp;</span>
        ) : (
          <span key={index}>{char}</span>
        )
      );
  };

  return (
    <div>
      <div className="logo">
      </div>

      <div className="menu" ref={menuRef}>
        <button className="close-button" onClick={handleCloseClick}>
        <IoMdClose />
        </button>
        <div className="col col-1">
          <div className="menu-logo">
            <Link to="/" className="text-white ml-5">EstateLand</Link>
          </div>
          <div className="links">
              <div className="link">
                <Link to="/house-list" className="text-white">
                  Listings
                </Link>
              </div>
              <div className="link">
                <Link to="/services_page/real-estate-brokerage" className="text-white">
                  Services
                </Link>
              </div>
              <div className="link">
                <Link to="/" className="text-white">
                  Main
                </Link>
              </div>
              <div className="link">
                <Link to="/contact" className="text-white">
                  Contact
                </Link>
              </div>
            </div>

            <div className="wrap_v">
              <div className="video-wrapper">
                <img src={houseListImage} alt="House Listing" />
              </div>  
            </div>

        </div>
        <div className="col col-2">
          <div className="socials">
            <div className="sub-col">
              <p>OAKS LANE SA</p>
              <p>Chemin Rieu 10, 1208 Geneva</p>
              <br />
              <strong className="text-white">PHONE:</strong>
              <p>+41 22 700 16 88</p>
            </div>
            <div className="sub-col">
              <p>Instagram</p>
              <p>LinkedIn</p>
              <p>Twitter</p>
              <p>Facebook</p>
              <br />
              <p>contact<br />@EstateLand.it</p>
            </div>
          </div>

          <div className="header">
            <h1>{splitTextIntoSpans("EstLand")}</h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Nav;